import {
	AlertBoxActionEnum,
	AlertBoxActionStateEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { z } from "zod";

// Runtime guard for a single entry of PortfolioAlertBoxDTO.performedActions.
// The generated type already models the shape, but the backend value flows in
// untrusted, so we validate each entry (and its performedAt ISO string) before
// deriving UI state from it.
export const alertActionStateSchema = z.object({
	action: z.nativeEnum(AlertBoxActionEnum),
	state: z.nativeEnum(AlertBoxActionStateEnum),
	performedAt: z.string(),
});

export type AlertBoxActionState = z.infer<
	typeof alertActionStateSchema
>["state"];

export type AlertBoxActionStateDTO = z.infer<typeof alertActionStateSchema>;
